


















































































import {Component, Vue} from 'vue-property-decorator';
import { GetClaimsNoRequest, OriginalAddress, ReturnAddress, PutReturnsNoReturnAddressRequest } from 'supporter';
import {ncpPopup, popupResize} from '@/utils/ncp';

@Component
export default class ModifyAddress extends Vue {

    private name: string = ''
    private contact1: string = ''
    private contact2: string = ''
    private zipCd: string = ''
    private address: string = ''
    private note: string = ''
    private detailAddress: string = ''
    private jibunAddress: string = ''
    private returnAddress!: ReturnAddress;
    private formatValidation = {
      contact1: false,
      contact2: false,
    }

    private created(){
        let claimNo = String(this.$route.query.claimNo);
        let request: GetClaimsNoRequest = {
            pathParams: {
                no: claimNo
            }        
        };
        this.$api.getClaimsNo(request).then((ret) => {
          const {
            name,
            contact1,
            contact2,
            zipCd,
            note,
            address,
            detailAddress,
          } = ret.data.returnAddress

          this.returnAddress = ret.data.returnAddress
          this.name = name
          this.contact1 = contact1
          this.contact2 = contact2
          this.zipCd = zipCd
          this.note = note
          this.address = address
          this.detailAddress = detailAddress
        })
    }

    private mounted(){
      document.body.classList.add('popup', 'popup_small');
      popupResize();
    }

    private goSelectReturnAddress() {
        (window as any).addressCallback = this.callbackReturn;
        ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('CLAIM_RETURNPOPUP_FINDZIPCODE'), 550, 880);
    }

    private callbackReturn(address: OriginalAddress) {
        (window as any).addressCallback = undefined;
        this.setAddressReturn(address);
    }

    private setAddressReturn(address: OriginalAddress) {
        this.zipCd = address.zipCode;
        this.address = address.roadAddress;
        this.detailAddress = address.roadAddressExtra;
        this.jibunAddress = address.jibunAddress
    }

    private isChangeAddress(): boolean {
      const isChanged = Object.keys(this.returnAddress)
        .some(returnAddressKey => this[returnAddressKey] !== this.returnAddress[returnAddressKey])

      return isChanged;
    }

    private validation(){
      if(this.name.trim() === ''){
        alert(this.$t('CLAIM_POPUP_RECEIVER_EMPTY_VALID_MESSAGE'));
        return false;
      }

      if(this.contact1.trim() === ''){
        alert(this.$t('CLAIM_POPUP_CONTACT_EMPTY_VALID_MESSAGE'));
        return false;
      }

      const hpRegExp = /^\d{3}-?\d{3,4}-?\d{4}$/;
      if (!hpRegExp.test(this.contact1)) {
        alert(this.$t('CLAIM_POPUP_CONTACT_FORMAT_VALID_MESSAGE'));
        return false;
      }

      return true;
    }

  private onCheckRefundAccountNo(e: KeyboardEvent): void {
    const $el = e.target as HTMLInputElement;
    if ($el.value.match(/[^0-9\-]+/g)) {
      this.formatValidation[$el.id] = true
      this[$el.id] = this[$el.id].replace(/[^0-9\-]+/g, '');
      return;
    }

    this.formatValidation[$el.id] = false;
  }

    private onClickModifyBtn(){
      if(!this.validation()){
        return
      }

      if (!this.isChangeAddress()) {
          alert(this.$t('CLAIM_RETURNPOPUP_ALERT15'));
          return;
      }

      let request: PutReturnsNoReturnAddressRequest = {
          pathParams: {
              no: String(this.$route.query.claimNo),
          },
          data: {
              note: this.note,
              address: this.address,
              name: this.name,
              jibunAddress: this.jibunAddress,
              detailAddress: this.detailAddress,
              zipCd: this.zipCd,
              contact1: this.contact1,
              contact2: this.contact2
          }
      }

      this.$api.putReturnsNoReturnAddress(request).then(()=>{
        alert(this.$t('CLAIM_RETURNPOPUP_ALERT16'));
        window.close();
        window.opener.location.reload();
      }).catch(err => {

      });
    }

    private close(): void {
      if (confirm(this.$t('CLAIM_CANCELPOPUP_CONFIRM1').toString())){
        window.close();
      }
    }
}
